<template>
  <div>
    <v-row class="actions-bar pa-4 bar-shadow primary-background">
      <v-col>
        <ProjectPageFilters
          :office-filter="projectOfficeFilter"
          :type-filter="projectTypeFilter"
          :project-name-filter="projectNameFilter"
          @changeFilter="changeFilter"
        />
      </v-col>
      <v-col
        v-if="isUserAdmin"
        class="actions"
      >
        <v-menu
          offset-y
          transition="scale-transition"
        >
          <template #activator="{ on: menu }">
            <Button
              id="add-project-button"
              color="primary"
              :on="menu"
            >
              {{ addProjectText }}
              <v-icon right small>mdi-menu-down</v-icon>
            </Button>
          </template>
          <v-list>
            <v-list-item @click="openAddFromScratch">
              <v-list-item-title>Create from scratch</v-list-item-title>
            </v-list-item>
            <v-list-item @click="openAddFromTemplate">
              <v-list-item-title>Create from template</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-col>
    </v-row>
    <v-row class="pa-4">
      <v-card>
        <ProjectTable
          :projects="projectsFiltered"
          @save="getProjects"
          @edit="openEditDialog"
        />
      </v-card>
    </v-row>

    <ProjectDialog
      :is-opened="isDialogOpened"
      :template-project="templateProject"
      @close="closeAddDialog"
      @save="getProjects"
    />

    <ProjectTemplateSelectDialog
      :is-opened="isTemplateSelectDialogOpened"
      @close="closeTemplateSelectDialog"
      @select="onTemplateProjectSelected"
    />

    <ProjectDialog
      :is-opened="isEditDialogOpened"
      :project="projectToEdit"
      @close="closeEditDialog"
      @save="getProjects"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import { Button } from '@/components/shared';

import ProjectDialog from './ProjectDialog.vue';
import ProjectPageFilters from './ProjectPageFilters.vue';
import ProjectTable from './ProjectTable.vue';
import ProjectTemplateSelectDialog from './ProjectTemplateSelectDialog.vue';

export default {
  components: {
    ProjectDialog,
    ProjectTemplateSelectDialog,
    Button,
    ProjectPageFilters,
    ProjectTable,
  },
  data() {
    return {
      isFiltersOpened: true,
      isDialogOpened: false,
      isTemplateSelectDialogOpened: false,
      isEditDialogOpened: false,
      projectToEdit: null,
      templateProject: null,
      addProjectText: 'Add Project',
    };
  },
  computed: {
    ...mapGetters('projects/filters', [
      'projectNameFilter',
      'projectOfficeFilter',
      'projectTypeFilter',
      'projectsFiltered',
    ]),
    ...mapGetters('auth/account', [
      'user',
      'isUserAdmin',
    ]),
  },
  async created() {
    await this.getAllProjectsForOptions();
    this.getProjects();
    this.getUserProjects();
  },
  methods: {
    ...mapActions('projects/filters', [
      'setNameFilter',
      'setProjectOfficeFilter',
    ]),
    ...mapActions('projects/filters', ['getProjectList', 'getAllProjectsForOptions']),
    ...mapActions('auth/account', ['getUserProjects']),

    changeFilter(value, filter) {
      if (filter === 'office-filter') {
        this.setProjectOfficeFilter(value);
      } else {
        this.setNameFilter(value);
      }
    },

    getProjects() {
      this.getProjectList();
      this.getAllProjectsForOptions();
    },
    openAddFromScratch() {
      this.templateProject = null;
      this.isDialogOpened = true;
    },
    openAddFromTemplate() {
      this.isTemplateSelectDialogOpened = true;
    },
    onTemplateProjectSelected(project) {
      this.templateProject = project;
      this.isDialogOpened = true;
    },
    openEditDialog(project) {
      this.projectToEdit = project;
      this.isEditDialogOpened = true;
    },
    closeAddDialog() {
      this.isDialogOpened = false;
      this.templateProject = null;
    },
    closeTemplateSelectDialog() {
      this.isTemplateSelectDialogOpened = false;
    },
    closeEditDialog() {
      this.isEditDialogOpened = false;
      this.projectToEdit = null;
    },
  },
};
</script>

<style lang="less">
@import "~@/styles/actions-bar";
</style>
